import { LocalStateSidebar } from './Sidebar.types'

export const SidebarDefaultLocalState: LocalStateSidebar = {
  isFolded: false,
  itemExpanded: 'NONE',
}
